import React from 'react'
import { useLocation } from 'react-router-dom'
import Breadcrumbs from '../components/Breadcrumbs/Breadcrumbs'
import Search from '../components/Search/Search'
import { useAppSelector } from '../redux/hooks'
import stringSimilarity from 'string-similarity'

import './styles/Search.scss'
import PaginatedList from '../components/PaginatedList/PaginatedList'

const SearchPage = () => {
    const location = useLocation()
    const searchField = location.search
    const products = useAppSelector((state) => state.productReducer)
    let productsToShow = products.filter(item =>
       stringSimilarity.compareTwoStrings(item.title, searchField) > .3
    )
  return (
    <main>
        <Breadcrumbs/>
        <section>
          <div className="searchList">
            <div className="container">
              <h1>Search Page</h1>
              <Search staticSearch={true}/>
              <div className="searchList-show">
                {<PaginatedList products={productsToShow} pageSize={35}/>}
              </div>
            </div>
          </div>
        </section>
    </main>
  )
}

export default SearchPage